import baseAPI from "@/http";

export const orcamentoAPI = {
  obterPainel: () => baseAPI.get("api/orcamento/painel"),
  obterCatalogos: () => baseAPI.get("api/orcamento/catalogos"),
  salvarProjeto: (id, dados) => id ? baseAPI.put(`api/orcamento/projetos/${id}`, dados) : baseAPI.post("api/orcamento/projetos", dados),
  excluirProjeto: id => baseAPI.delete(`api/orcamento/projetos/${id}`),
  salvarAcao: (id, dados) => id ? baseAPI.put(`api/orcamento/acoes/${id}`, dados) : baseAPI.post("api/orcamento/acoes", dados),
  excluirAcao: id => baseAPI.delete(`api/orcamento/acoes/${id}`),
  salvarPlanejamento: (id, dados) => id ? baseAPI.put(`api/orcamento/planejamentos/${id}`, dados) : baseAPI.post("api/orcamento/planejamentos", dados),
  excluirPlanejamento: id => baseAPI.delete(`api/orcamento/planejamentos/${id}`),
  salvarContratacao: (id, dados) => id ? baseAPI.put(`api/orcamento/contratacoes/${id}`, dados) : baseAPI.post("api/orcamento/contratacoes", dados),
  excluirContratacao: id => baseAPI.delete(`api/orcamento/contratacoes/${id}`),
  salvarEntrega: (id, dados) => id ? baseAPI.put(`api/orcamento/entregas/${id}`, dados) : baseAPI.post("api/orcamento/entregas", dados),
  excluirEntrega: id => baseAPI.delete(`api/orcamento/entregas/${id}`),
  salvarPagamento: (id, dados) => id ? baseAPI.put(`api/orcamento/pagamentos/${id}`, dados) : baseAPI.post("api/orcamento/pagamentos", dados),
  excluirPagamento: id => baseAPI.delete(`api/orcamento/pagamentos/${id}`),
};
